import React from 'react';
import Footer from './Footer';

const FooterApp: React.FC = () => {
	return <Footer />;
};

export default FooterApp;
